
<template>
    <div id="projects">
        <h1>Your projects</h1>
            <table id="table-large"><!--visible on larger screens--> 
            <thead>
                <tr>
                    <th width="30%" scope="col">Project number</th>
                    <th width="34%" scope="col">Project description</th>
                    <th width="18%" scope="col">Quota</th>
                    <th width="18%" scope="col">Usage</th>
                </tr>
            </thead>
            <tbody v-if="!loading && !loadError">
                <ProjectItem v-for="project in projectData" 
                    :key="project.prjnum"
                    :number="project.prjnum"
                    :desc="project.title"
                    :quota="project.quota"
                    :usage="project.usage"
                    @click="projectClick(project.prjnum)"
                    :class="{'active-project': project.prjnum === this.$route.params.prjnum}" 
                />
            </tbody>
            </table>
            <div class="table-small-container">
            <ProjectTableMobile v-for="project in projectData" 
                :key="project.prjnum" 
                :number="project.prjnum"
                :desc="project.title"
                :quota="project.quota"
                :usage="project.usage"
                @project-clicked="projectClick(project.prjnum)"
            /><!--visible on small screens-->
            </div>

        <div v-if="loading" class="sk-circle-container">
            <div class="sk-circle">
                <div class="sk-circle-dot"></div>
                <div class="sk-circle-dot"></div>
                <div class="sk-circle-dot"></div>
                <div class="sk-circle-dot"></div>
                <div class="sk-circle-dot"></div>
                <div class="sk-circle-dot"></div>
                <div class="sk-circle-dot"></div>
                <div class="sk-circle-dot"></div>
                <div class="sk-circle-dot"></div>
                <div class="sk-circle-dot"></div>
                <div class="sk-circle-dot"></div>
                <div class="sk-circle-dot"></div>
            </div>
        </div>
        <p v-if="loadError" class="mt-m">There was an error loading your projects</p>
    </div>
</template>

<script>

import ProjectItem from './ProjectItem.vue';
import ProjectTableMobile from './ProjectTableMobile.vue';

export default {
    name: "ProjectList",
    components: {
        ProjectItem,
        ProjectTableMobile
    },
    data (){
        return {
            loading: false, //TODO implement through vuex store
            loadError: false //TODO implement through vuex store
           
        }
    },
    computed: {
        projectData () {
            return this.$store.state.projectData;
        }
    },
    methods: {
        projectClick(num) {
            this.$router.push('/projects/' + num);
        }
    },
    mounted() {
    this.$store.dispatch('getProjectData');
    this.$store.dispatch('getKeyLimits');
  }
}
</script>

<style>

#projects {
    margin: 3rem 5rem 3rem 5rem;
}

#table-large {
    margin-top: 2.5rem;
}

#table-large, .table-small-container table {
    text-align: left;
    font-size: 0.9rem;
    line-height: 1.5rem;
}

#table-large tr {
  border-bottom: 1px solid var(--blue-gray);
}

.table-small-container {
    display: none;
    margin-top: 2rem;
}

.table-small-container table{
    margin-bottom: 1.5rem;
}

.active-project {
    background-color: var(--blue-selected);
}


@media screen and (max-width: 800px) {
    #projects {
        margin: 1.5rem 1.5rem 3rem 1.5rem;
    }
}

@media screen and (max-width: 600px) {
    #table-large {
        display: none;
    }
    .table-small-container {
        display: block;
    }
}
</style>